import React from 'react';
import { noraWebTheme } from './noraWebTheme';
import createTheme from '@mui/material/styles/createTheme';

export const LinkTheme = createTheme(noraWebTheme,{
  components: {
    // Name of the component
    MuiListItemText: {
      styleOverrides: {
        // Name of the slot
        primary: {
          // Some CSS
          [noraWebTheme.breakpoints.down('md')]: {
            fontSize: '1rem',
            fontWeight:'Bold',
            m:0,
            p:0,
          },
          [noraWebTheme.breakpoints.up('md')]: {
            fontSize: '1.2rem',
            fontWeight:'Bold',
          },
        },
        root:{
          m:0,
          p:0,
        },
        dense: {
          m:0,
          p:0,
        }
      },
    },
  },
});